<app-run-details [jobId]="jobId"></app-run-details>
